import React, {Component} from 'react';
import fire from '../../fire.js';
import './ThankfulPage.css';
import CardComponent from '../../components/CardComponent/CardComponent.js';
import logoBlue from '../../assets/logo_thankfully_blue.png';
import logoGrey from '../../assets/logo_thankfully_grey.png';
import logoBlack from '../../assets/logo-thankfully.png';
import {Link} from 'react-router-dom';
import embedCssOverride from '../embedCssOverride'
import Confetti from 'react-dom-confetti';
import headerImageLarge from '../../assets/confetti-wide-2x.png';
import headerImageNarrow from '../../assets/confetti-narrow-2x.png';
import downloadFromAppStore from '../../assets/button-appstore.png'
import Footer from '../Footer';

const config1 = {
    angle: 35,
    spread: 146,
    startVelocity: 89,
    elementCount: 190,
    decay: 0.8
};const config2 = {
    angle: 125,
    spread: 146,
    startVelocity: 89,
    elementCount: 190,
    decay: 0.8
};

const firestore = fire.firestore();
const settings = {/* your settings... */ timestampsInSnapshots: true};
firestore.settings(settings);


export default class ThankfulPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            thanksData: null,
            firstName: null,
            lastName: null,
            fullName: null,
            confetti: false
        };
    }

    setImageSize = () => {
        if(window.innerWidth < 768) {
            this.setState({narrow: true})
        } else {
            this.setState({narrow: false})
        }
    };

    async componentDidMount() {
        const handleThanksData = (thanks) => {
            const thanksData = thanks.data();
            if (!thanksData) return;

            console.log("thanksData", thanksData);


            firestore.collection('users').doc(thanksData.uid).get()
                .then(async user => {
                    let userData = user.data();
                    let fullName = 'Anonymous';
                    let firstName = 'Anonymous';
                    let lastName = null;
                    let profilePic = null;
                    if (userData.name) {
                        fullName = userData.name;
                        firstName = fullName.split(' ')[0];
                        lastName = fullName.split(' ')[1];
                        profilePic = userData.profilePic;

                    }

                    const recipients = [];
                    let recipientUids = Object.keys(thanksData.recipients);
                    await recipientUids.map(async (recipientUserUid) => {
                        if(recipientUserUid === thanksData.uid) {
                            return;
                        }
                        const recipient = await firestore.collection('users').doc(recipientUserUid).get();
                        let recipientData = recipient.data();

                        recipientData.firstInitial = recipientData.name.substring(0,1);
                        recipientData.secondInitial = recipientData.name.substring(recipientData.name.indexOf(" ")).trim().substring(0,1);

                        console.log("recipient", recipientData);
                        this.setState({
                            recipients: [recipientData].concat(this.state.recipients)
                        });
                    });

                    const nonMembers = (thanksData.notmembersNames || []).filter( (el, i, arr) => arr.indexOf(el) === i);

                    nonMembers.forEach((el) => {
                        const firstInitial = el.substring(0,1);
                        const secondInitial = el.substring(el.indexOf(" ")).trim().substring(0,1);
                        recipients.push({
                            name: el,
                            firstInitial,
                            secondInitial,
                        });
                    });

                    this.setState({
                        recipients,
                        thanksData,
                        firstName,
                        fullName,
                        lastName,
                        profilePic,
                        dateSent: thanksData.timestamp,
                        confetti: true
                    });
                });
        };

        var url = new URL(window.location.href);
        var thanksId = url.searchParams.get("id");
        var postId = url.searchParams.get("postId");


        if (thanksId) {
            firestore
                .collection('thanks').doc(thanksId).get()
                .then(handleThanksData);
        }
        else if (postId) {
            firestore
                .collection('posts').doc(postId).get()
                .then(handleThanksData);
        }
        else {

        }
        this.setImageSize()
    }

    render() {
        console.log("state: ", this.state);

        if (this.state.thanksData) {
            let dateSent = "";
            if(this.state.thanksData.timestamp) {
                const date = new Date(0);
                date.setSeconds(parseInt(this.state.thanksData.timestamp.seconds));
                const options = { year: 'numeric', month: 'long', day: 'numeric' };
                dateSent = date.toLocaleDateString("en-US", options);
            }

            return (
                <div>
                    <div className="page-container">
                        <Confetti active={this.state.confetti} config={config1}/>
                        <Confetti active={this.state.confetti} config={config2}/>
                        <a href="/"><img className="logo" src={logoBlack}/></a>
                        <CardComponent
                            dateSent={dateSent}
                            recipients={this.state.recipients}
                            profilePic={this.state.profilePic}
                            picture={this.state.thanksData.imageURL}
                            headerImage={this.state.narrow ? headerImageNarrow : headerImageLarge}
                            name={this.state.fullName}
                            message={this.state.thanksData.text}
                            firstInitial={this.state.firstName[0].toUpperCase()}
                            secondInitial={this.state.lastName ? this.state.lastName[0].toUpperCase() : ''}
                        />
                        <br/><br/>
                    </div>
                    <Footer saveCard={true}/>
                </div>
            )
        } else {
            return (
                <div>
                    <div className="page-container">
                        <Confetti active={this.state.confetti} config={config1}/>
                        <Confetti active={this.state.confetti} config={config2}/>
                    </div>
                </div>
            )
        }

    };

}



// WEBPACK FOOTER //
// ./src/components/ThankfulPage/ThankfulPage.js